import {
  CharacterStream,
  State as GraphqlState,
  onlineParser,
} from 'graphql-language-service';
import { clone, isEqual } from 'lodash';
import * as monacoEditor from 'monaco-editor';

export const graphqlTokensProvider: monacoEditor.languages.TokensProvider = {
  getInitialState() {
    return {
      ...onlineParser().startState(),
      clone() {
        return clone(this);
      },
      equals(additionalState) {
        return isEqual(this, additionalState);
      },
    };
  },
  tokenize(line, initialState: unknown) {
    const stream = new CharacterStream(`${line}\n`);
    const parser = onlineParser();
    const tokens = [];
    const state = initialState as GraphqlState;

    while (!stream.eol()) {
      const startIndex = stream.getCurrentPosition();
      const tokenType = parser.token(stream, state);
      const graphqlRuleKind = state.kind?.toLowerCase();
      // Top level of field strings should be treated like comments
      const isStringComment =
        tokenType === 'string' &&
        state.prevState?.kind &&
        ['Definition', 'FieldDef', 'EnumValueDef', 'InputValueDef'].includes(
          state.prevState.kind,
        );

      // Values passed to arguments can be multiline strings. In the parser we
      // have patched their handling to treat all as comments. We should undo this
      // and treat them as string values instead.
      const isMultilineArgumentValue =
        tokenType === 'comment' && state.prevState?.kind === 'Argument';

      tokens.push({
        startIndex,
        scopes: isStringComment
          ? 'comment.graphql'
          : isMultilineArgumentValue
            ? `string.stringValue.graphql`
            : `${tokenType}.${graphqlRuleKind}.graphql`,
      });
    }

    return {
      tokens,
      endState: {
        ...(state as GraphqlState),
        clone() {
          return clone(this);
        },
        equals(additionalState) {
          return isEqual(this, additionalState);
        },
      },
    };
  },
};
